import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column footer-brand-section">
              <div className="footer-logo-group">
                <span className="footer-brand-name">BidWally</span>
              </div>
              <p className="footer-description section-content">
                {' '}
                The non-custodial crypto marketplace for peer-to-peer local
                discovery. Buy, sell, and trade with trust and transparency.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-trust-badges">
                <div className="footer-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </svg>
                  <span className="footer-badge-text">Verified Sellers</span>
                </div>
                <div className="footer-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042l-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893l-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042l.348-1.97M7.48 20.364l3.126-17.727"></path>
                  </svg>
                  <span className="footer-badge-text">Non-Custodial</span>
                </div>
              </div>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">Marketplace</h3>
              <ul className="footer-links">
                <li>
                  <a href="/">
                    <div className="footer-link">
                      <span>Home</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/map-view">
                    <div className="footer-link">
                      <span>Local Map View</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/category-browse">
                    <div className="footer-link">
                      <span>All Categories</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#" className="link-disabled" aria-disabled="true" tabIndex="-1">
                    <div className="footer-link">
                      <span>Post a Listing</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/seller-profile">
                    <div className="footer-link">
                      <span>Seller Directory</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">
                Trust &amp; Safety
              </h3>
              <ul className="footer-links">
                <li>
                  <a href="/trust-safety">
                    <div className="footer-link">
                      <span>Safety Center</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#" className="link-disabled" aria-disabled="true" tabIndex="-1">
                    <div className="footer-link">
                      <span>Escrow Roadmap</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Verification Process</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Reporting Scams</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Community Flags</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">Connect</h3>
              <div className="footer-social-grid">
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="GitHub" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5c.08-1.25-.27-2.48-1-3.5c.28-1.15.28-2.35 0-3.5c0 0-1 0-3 1.5c-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.4 5.4 0 0 0 4 9c0 3.5 3 5.5 6 5.5c-.39.49-.68 1.05-.85 1.65S8.93 17.38 9 18v4"></path>
                        <path d="M9 18c-4.51 2-5-2-7-2"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
              <p className="footer-newsletter-text section-content">
                Stay updated on our non-custodial roadmap.
              </p>
              <form
                action="/subscribe"
                method="POST"
                data-form-id="b0ef725e-5aa4-4a07-81b5-79188e78ad93"
                className="footer-newsletter-form"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required="true"
                  aria-label="Email address"
                  id="thq_email_3Meg"
                  data-form-field-id="thq_email_3Meg"
                  className="footer-input"
                />
                <button
                  type="submit"
                  id="thq_button_jWOo"
                  name="button"
                  data-form-field-id="thq_button_jWOo"
                  className="btn btn-primary btn-sm"
                >
                  Join
                </button>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="footer-copyright">
                &amp;copy; 2026 BidWally Marketplace. Non-custodial,
                peer-to-peer protocol.
              </p>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Cookie Settings</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
const footerForms = document.querySelectorAll('.footer-newsletter-form');

footerForms.forEach(form => {
  form.addEventListener('submit', (e) => {
    const emailInput = form.querySelector('.footer-input');
    
    if (emailInput && emailInput.checkValidity()) {
      const originalContent = form.innerHTML;
      
      form.innerHTML = \`
        <div style="color: var(--color-accent); font-size: var(--font-size-sm); font-weight: var(--font-weight-medium); display: flex; align-items: center; gap: 8px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
          Subscribed
        </div>
      \`;
      
      setTimeout(() => {
        form.innerHTML = originalContent;
        form.reset();
      }, 3000);
    }
  });
});
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
